import { createContext } from 'react';

// Carries two things WorkflowBuilder owns down to DraggableEdge: { setEdges, openMenu }.
//
// setEdges: DraggableEdge can't just call React Flow's own useReactFlow().setEdges —
// WorkflowBuilder passes `edges` to <ReactFlow> as a CONTROLLED prop, so the source of truth is
// WorkflowBuilder's state, not React Flow's internal store. Updating the store directly gets
// silently reverted on the next render, when React Flow re-syncs the store from the (unchanged)
// controlled prop — so dragging/adding/removing a waypoint would appear to do nothing. Routing
// through the real setEdges avoids that.
//
// openMenu(event, title, items): opens WorkflowBuilder's shared right-click context menu overlay
// (the same one used for the multi-select align/indent menu and the edge right-click menu) at
// the event's position, with the given title and [{ key, label, onClick }] items — used for
// "Delete Waypoint".
//
// A context is used (rather than putting these on edge.data) because edgeTypes must stay a
// referentially-stable object defined outside the component.
export const WorkflowEdgesContext = createContext(null);
